'use es6';

import UIMediaObject from 'UIComponents/layout/UIMediaObject';
import UISection from 'UIComponents/section/UISection';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UILink from 'UIComponents/link/UILink';
import UIPanel from 'UIComponents/panel/UIPanel';
import UIPanelBody from 'UIComponents/panel/UIPanelBody';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIPanelHeader from 'UIComponents/panel/UIPanelHeader';
import { H4 } from 'UIComponents/elements/headings';
import { useDispatch } from 'react-redux';
import UIIllustration from 'UIComponents/image/UIIllustration';
import { useMemo } from 'react';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { IconCircle } from 'foundations-components/transitional/components/IconCircle';
import { Text } from 'foundations-components/components/Text';
import { WarningIcon } from 'foundations-assets';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const Issues = ({
  issues,
  iconBgColor,
  issueLabel,
  onIssueClick
}) => {
  if (issues.length === 0) {
    return null;
  }
  return /*#__PURE__*/_jsxs(UISection, {
    children: [/*#__PURE__*/_jsx(UISection, {
      children: /*#__PURE__*/_jsx(UIMediaObject, {
        className: "m-left-8",
        align: "center",
        itemLeft: /*#__PURE__*/_jsx(IconCircle, {
          icon: WarningIcon,
          size: "100",
          color: "icon-positive-on-fill-default",
          backgroundColor: iconBgColor
        }),
        children: /*#__PURE__*/_jsx("strong", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: issueLabel
          })
        })
      })
    }), /*#__PURE__*/_jsx(UISection, {
      children: /*#__PURE__*/_jsx(List, {
        ordered: true,
        styled: true,
        children: issues.map((issue, index) => {
          const {
            node
          } = issue;
          return /*#__PURE__*/_jsx(ListItem, {
            marginInlineStart: "200",
            marginInlineEnd: "200",
            children: /*#__PURE__*/_jsx(UILink, {
              use: "unstyled",
              onClick: () => onIssueClick(issue),
              children: node
            }, index)
          }, index);
        })
      })
    })]
  });
};
const EmptyState = () => {
  return /*#__PURE__*/_jsxs(Text, {
    as: "div",
    textAlign: "center",
    padding: "600",
    children: [/*#__PURE__*/_jsx(UIIllustration, {
      name: "success-green",
      width: "30%"
    }), /*#__PURE__*/_jsxs("div", {
      className: "m-top-4 m-bottom-4",
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h5",
        marginBlockEnd: "400",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "warningsAndSuggestionsPanel.emptyState.title"
        })
      }), /*#__PURE__*/_jsx(Text, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "warningsAndSuggestionsPanel.emptyState.body"
        })
      })]
    })]
  });
};
const WarningsAndSuggestionsPanel = ({
  errorLabels,
  warningLabels,
  onIssueClick,
  onClose
}) => {
  const dispatch = useDispatch();
  const issueClickHandler = ({
    target,
    onClickData
  }) => {
    dispatch(onIssueClick(target, onClickData));
  };
  const shouldShowEmptyState = useMemo(() => {
    if (errorLabels && errorLabels.length > 0) {
      return false;
    }
    if (warningLabels && warningLabels.length > 0) {
      return false;
    }
    return true;
  }, [errorLabels, warningLabels]);
  return /*#__PURE__*/_jsxs(UIPanel, {
    children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
      onClick: onClose
    }), /*#__PURE__*/_jsx(UIPanelHeader, {
      children: /*#__PURE__*/_jsx(H4, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "approvals.warningsAndSuggestions"
        })
      })
    }), /*#__PURE__*/_jsx(UIPanelBody, {
      children: /*#__PURE__*/_jsx("div", {
        className: "m-top-8",
        children: shouldShowEmptyState ? /*#__PURE__*/_jsx(EmptyState, {}) : /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(Issues, {
            issues: errorLabels,
            iconBgColor: "border-alert-default",
            issueLabel: "epIssueButton.errorLabel",
            onIssueClick: issueClickHandler
          }), /*#__PURE__*/_jsx(Issues, {
            issues: warningLabels,
            iconBgColor: "border-caution-default",
            issueLabel: "epIssueButton.warningLabel",
            onIssueClick: issueClickHandler
          })]
        })
      })
    })]
  });
};
export default WarningsAndSuggestionsPanel;